import DOMPurify from 'dompurify';

// Nettoie le HTML reçu de l'API (contenus juridiques, surlignages ES) avant un
// dangerouslySetInnerHTML : retire <script>, <object>/<iframe>, attributs on*, URLs javascript:.
export const sanitizeHtml = (html?: string | null): string => DOMPurify.sanitize(html ?? '');
